import React from 'react';
import PreFormGoldSilver from '../../../../../common/PreFormGoldSilver';
import { useLocation } from 'react-router-dom';

const ValidateRutMobile = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const motiveId = params.get('motiveId');
  return (
    <PreFormGoldSilver
      mobile
      motiveId={motiveId}
      issueFormName={'goldSilverDispatchCharge'}
    />
  );
};

export default ValidateRutMobile;
